import { fetcher } from "../../utils/fetcher";

const API_BASE = import.meta.env.VITE_API_URL;

/**
 * Fetch all projects for a user
 */
export const fetchProjects = async (userId) => {
  const url = `/api/projects?userId=${userId}`;
  return await fetcher.get(url);
};

/**
 * Fetch a single project by ID
 */
export const fetchProjectById = async (projectId, userId) => {
  const query = userId ? `?userId=${userId}` : "";
  const url = `/api/projects/${projectId}${query}`;
  return await fetcher.get(url);
};

/**
 * Create a new project
 */
export const createProject = async (projectData) => {
  const url = `/api/projects`;
  return await fetcher.post(url, projectData);
};

/**
 * Update a project
 */
export const updateProject = async (projectId, projectData) => {
  const url = `/api/projects/${projectId}`;
  return await fetcher.put(url, projectData);
};

/**
 * Delete a project (soft delete)
 */
export const deleteProject = async (projectId) => {
  const url = `/api/projects/${projectId}`;
  return await fetcher.delete(url);
};

/**
 * Update project members and teams
 */
export const updateProjectMembers = async (
  projectId,
  { teamIds, memberIds }
) => {
  const url = `/api/projects/${projectId}/members`;
  return await fetcher.put(url, { teamIds, memberIds });
};

/**
 * Send project invite
 */
export const sendProjectInvite = async (projectId, email, note, token) => {
  try {
    const response = await fetch(
      `${API_BASE}/api/projects/${projectId}/invite`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ email, note }),
      }
    );

    if (response.status === 401) {
      // Import dynamically to avoid circular dependency
      const { default: useAuthStore } = await import("../../store/authStore");
      useAuthStore.getState().logout();
      window.location.href = "/#/login";
      throw new Error("Authentication failed. Please login again.");
    }

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to send project invite");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error sending project invite:", error);
    throw error;
  }
};
